<template>
  <div>
    <page-toolbar>
      <rate-toolbar @change="onChange" :rate-type="rateType" v-slot="slotProps">
        <kendo-button type="button" title="Export to Excel" @click="exportToExcel">
          <i class="k-icon k-i-excel"></i>
        </kendo-button>
      </rate-toolbar>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 165px)"
      ref="rateGrid"
      :dataSource="dataSource"
      :editable="false"
      :filterable="true"
      :sortable="true"
      :columns="columns"
    >
    </kendo-grid>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'
import PageToolbar from '@/components/PageToolbar'
import RateToolbar from './RateToolbar'

export default {
  name: 'InterestRate',
  props: {
    rateType: {
      type: Number,
      required: true,
    },
  },
  components: {
    PageToolbar,
    RateToolbar,
  },
  data() {
    return {
      evaluationDateOa: 0,
      gridColumns: [],
      data: [],
    }
  },
  computed: {
    editable() {
      return this.role != 'Guest'
    },
    dataSource() {
      if (!this.data) return
      return new kendo.data.DataSource({
        //type: 'aspnetmvc-ajax',
        transport: {
          read: options => {
            options.success(this.data)
          },
        },
        schema: {
          model: {
            fields: {
              EndDate: {type: 'date'},
            },
          },
        },
      })
    },
    columns() {
      if (!this.gridColumns) {
        return
      }
      return this.getGridColumns(this.gridColumns)
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },

  methods: {
    onChange(e) {
      this.getData(e.evaluationDateOa)
      this.evaluationDateOa = e.evaluationDateOa
    },
    getData: async function(evaluationDateOa) {
      const req = await axios
        .get('/api/heroux/rate/readCurrencyRates', {
          params: {
            evaluationDateOa: evaluationDateOa,
            rateType: this.rateType,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error getting dataSource', 'error'))
      const response = req.data
      const {columns, data} = response
      this.gridColumns = columns
      this.data = data
    },
    getGridColumns(columns) {
      const gridColumns = columns.map(column => ({
        ...column,
        width: 120,
        //field: '["' + column.curveName + '_' + 0 + '"]',
        field: '["' + column.curveName + '"]',
        title: column.title,
        filterable: false,
        attributes: {style: 'text-align: right;'},
        format: '{0:n5}',
      }))

      return [
        {
          field: 'EndDate',
          title: 'End Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        ...gridColumns,
        {},
      ]
    },
    exportToExcel() {
      window.location.href = `/api/heroux/rate/exportToExcel?evaluationDateOa=${
        this.evaluationDateOa
      }&rateType=${this.rateType}&t=${this.tokenString}`
    },
  },
}
</script>
